import { Button, Checkbox, Form, Input, Select, Space } from "antd";
import { Link, useParams } from "react-router-dom";
import SelectDownIcon from "../../../../assets/icons/SelectDownIcon";
import CustomCard from "../../../../components/common/CustomCard";
import SidebarLayout from "../../../../layouts/SidebarLayout";

export default function AddEditUserGroup() {
  const { id } = useParams();
  const [form] = Form.useForm();

  const onFinish = (values: any) => {};

  const features = Array(6).fill("Feature's title");
  const modules = Array(7).fill("Module Title");

  return (
    <>
      <SidebarLayout
        title={`${id ? `Edit` : `Create`} User Group`}
        backLink={`/admin/users-roll-access/user-group`}
      >
        <Form
          className="custom-form"
          layout="vertical"
          requiredMark="optional"
          size="large"
          onFinish={onFinish}
          form={form}
        >
          <CustomCard className=" p-6 pb-0 rounded-b-none">
            <div className="grid grid-cols-2 gap-4 mb-3">
              <Form.Item
                label="Select Product"
                name="product"
                rules={[
                  {
                    required: true,
                    message: "Please select product",
                  },
                ]}
              >
                <Select
                  mode="multiple"
                  placeholder="Select product"
                  className="w-full"
                  suffixIcon={<SelectDownIcon />}
                />
              </Form.Item>
              <Form.Item
                name=""
                label="Group Name"
                className="mb-4"
                rules={[
                  {
                    required: true,
                    message: "Please enter a Group Name",
                  },
                ]}
              >
                <Input size="large" placeholder="Enter group name" />
              </Form.Item>
            </div>

            <div className="w-full mb-3 px-3 py-1.5 bg-[#f0f3f8] rounded-md flex items-center justify-between">
              <div className="flex items-center gap-4">
                <div className="text-display-body text-lg font-semibold leading-[30px]">
                  Permission Access
                </div>

                <Form.Item className="mt-2">
                  <Checkbox className="flex items-center">
                    <span className="text-[#4a71ff] text-sm font-medium leading-normal">
                      Select All
                    </span>
                  </Checkbox>
                </Form.Item>
              </div>

              <div className="text-[#fe7235] text-sm font-medium leading-normal">
                Unselect
              </div>
            </div>

            <div className="border border-[#E2E8F0] mt-4 mb-4">
              {modules.map((module, rowIndex) => (
                <div key={rowIndex} className="flex border-b border-[#E2E8F0]">
                  <div className="w-40 p-2 font-semibold border-r border-[#E2E8F0] flex items-center bg-[#FFF5F4]">
                    {module}
                  </div>
                  <div className="grid grid-cols-6 flex-1">
                    {features.map((feature, colIndex) => (
                      <div
                        key={`${rowIndex}-${colIndex}`}
                        className="p-2 border-r border-[#E2E8F0] flex items-center gap-2"
                      >
                        <Checkbox />
                        <span className="text-sm">{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </CustomCard>

          {/* sticky bottom-0 */}
          <div className="p-6 rounded-md rounded-t-none bg-white border border-t-0 border-light">
            <Space className="w-full mt-2" size={12}>
              <Link to={`/admin/users-roll-access/user-group`}>
                <Button
                  className="normal-dark-button modal-button"
                  size="middle"
                >
                  Cancel
                </Button>
              </Link>
              <Button
                className="modal-button"
                type="primary"
                htmlType="submit"
                size="middle"
                // loading={id ? updateSingleUserIsLoading : isCreateUserLoading}
              >
                {id ? "Update" : "Create"}
              </Button>
            </Space>
          </div>
        </Form>
      </SidebarLayout>
    </>
  );
}
